export default "__VITE_ASSET__DHivd8CC__"